module.exports = __webpack_public_path__ + "static/media/Pangolin.cb27ae96.ogg";